import { useMutation, useQueryClient, mutationOptions } from '@tanstack/react-query';

import {
	insertSingleEmailOfCampaign,
	updateSingleEmailData,
	deleteSingleEmailOfCampaign,
} from '../../api/emailMailsApi';
import { emailCampaignsKeys } from '../emailCampaigns/keys';

import { emailCampaignMailsMutationKeys } from './keys';

export const insertSingleEmailOfCampaignOptions = (queryClient) =>
	mutationOptions({
		mutationKey: emailCampaignMailsMutationKeys.insert,
		mutationFn: ({ campaignId, emailTemplateId, delayDays }) =>
			insertSingleEmailOfCampaign({
				campaignId,
				emailTemplateId,
				delayDays,
			}),
		onSuccess: (_, { campaignId }) => {
			queryClient.invalidateQueries({ queryKey: emailCampaignsKeys.detail(campaignId) });
		},
	});

export function useInsertSingleEmailOfCampaign() {
	const qc = useQueryClient();
	return useMutation(insertSingleEmailOfCampaignOptions(qc));
}

export const updateSingleEmailDataOptions = (queryClient) =>
	mutationOptions({
		mutationKey: emailCampaignMailsMutationKeys.update,
		mutationFn: ({ stepId, campaignId, updates }) =>
			updateSingleEmailData({
				stepId,
				campaignId,
				updates,
			}),
		onSuccess: (_, { campaignId }) => {
			if (campaignId) {
				queryClient.invalidateQueries({ queryKey: emailCampaignsKeys.detail(campaignId) });
			}
		},
	});

export function useUpdateSingleEmailData() {
	const qc = useQueryClient();
	return useMutation(updateSingleEmailDataOptions(qc));
}

export const deleteSingleEmailOfCampaignOptions = (queryClient) =>
	mutationOptions({
		mutationKey: emailCampaignMailsMutationKeys.delete,
		mutationFn: ({ campaignId, stepId }) =>
			deleteSingleEmailOfCampaign({
				campaignId,
				stepId,
			}),
		onSuccess: (_, { campaignId }) => {
			queryClient.invalidateQueries({ queryKey: emailCampaignsKeys.detail(campaignId) });
		},
	});

export function useDeleteSingleEmailOfCampaign() {
	const qc = useQueryClient();
	return useMutation(deleteSingleEmailOfCampaignOptions(qc));
}
